import React from "react";
import {InvoiceCreate} from "../components/InvoiceCreate";

export const InvoiceCreatePage = () => {

    return  (
        <div>
            <InvoiceCreate />
        </div>
    )

}